module.exports = "<span>\r\n  {{ ::$ctrl.phone | mask: $ctrl.phoneMask }}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-phone/rw-phone.html
// module id = 1934
// module chunks = 0